export default __webpack_public_path__ + "static/media/CV5.e3d9044d.png";